import React, { Component } from 'react';
import './documentmanagement.css';
import { AccessibleDataTable } from '../../AccessibleDataTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faCheck, faTimes, faEye } from '@fortawesome/free-solid-svg-icons';

export class DocumentManagement extends Component {
    static displayName = DocumentManagement.name;

    constructor(props) {
        super(props);
        this.state = {
            documents: []
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let documents = this.state.documents;

        let tableRows = [];
        if (documents.length > 0) {
            for (var i = 0; i < documents.length; i++) {
                let document = documents[i];

                if (document.status == "Deleted") continue;

                let timestamp = new Date(document.timestamp.toString());
                let timestampFormat = (timestamp.getMonth() + 1) + "/" + timestamp.getDate() + "/" + timestamp.getFullYear();

                let row = {
                    editDocument: <a href={'UpdateDocument/' + document.id} className='update-btn' title='Edit' aria-label="Edit document"><FontAwesomeIcon icon={faEdit} aria-hidden="true" /></a>,
                    name: document.name,
                    type: document.type,
                    description: document.description,
                    //uploader: document.uploader,
                    timestamp: timestampFormat
                };
                tableRows.push(row);
            }
        }

        let table = {
            columns: [
                { label: '', field: 'editDocument' },
                { label: 'Name', field: 'name', sort: 'asc' },
                { label: 'Type', field: 'type', sort: 'asc' },
                { label: 'Description', field: 'description', sort: 'asc' },
                /*{ label: 'Uploader', field: 'uploader', sort: 'asc' },*/
                { label: 'Timestamp', field: 'timestamp', sort: 'asc' }
            ],
            rows: tableRows
        };

        return (
            <div className='document-management'>
                <div className='page-title'>
                    <h1>Document Management</h1>
                </div>

                <div className='table-container'>
                    <a href='/CreateDocument' title='Upload a document'><button className='form-management-button'>Upload Document</button></a>
                    <a href='/DocumentDeletion' title='Delete Documents'><button className='form-management-button'>Delete Documents</button></a>
                    <AccessibleDataTable caption="Document Management" entries={100} data={table} />
                </div>
            </div>  
        );
    }

    async getComponentData() {
        const response = await fetch('AdminDocument/GetDocuments', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            documents: data
        });
    }
}
